import React, { Component } from "react";
import ReactDOM from "react-dom";

export default class NextArrow extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const { left, style, top, theme } = this.props;
    const isMinimal = theme == "minimal";

    return (
      <a
        className="btn-floating btn-previous position-absolute btn-small white-text z-depth-0 m-0 d-flex justify-content-center align-items-center"
        style={{
          ...style,
          top: !_.isEmpty(top) ? top : "50%",
          left: !_.isEmpty(left) ? left : "-45px",
          width: "33px",
          height: "33px",
          backgroundColor: isMinimal ? "transparent" : "#00000060",
        }}
        onClick={this.props.onClick}
      >
        <i className="fa fa-chevron-left" style={{ color: isMinimal ? "#00000060" : "white" }}></i>
      </a>
    );
  }
}



// WEBPACK FOOTER //
// ./resources/js/components/Shared/PrevArrow.js